(function($) {

	$.fn.gallery = function() {

		var elem = $(this),
			body = $('body'),
			target = elem.find('.js-gallery__target'),
			thumbControls = elem.find('.js-gallery__thumb-control'),
			prevButton = elem.find('.js-gallery__prev-button'),
			nextButton = elem.find('.js-gallery__next-button'),
			closeButton = elem.find('.js-gallery__close'),
			slides = elem.find('.js__gallery__slide'),
			settings = {
				libUrl: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js',
				thumbIndexAttr: 'data-index',
				hiddenClass: 'is-hidden',
				activeClass: 'is-active',
				fullscreenClass: 'is-fullscreen',
				captionSelector: '.js__gallery__caption',
				imageSelector: '.js__gallery__image',
				pluginSettings: {
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					autoplay: false,
					prevArrow: prevButton,
					nextArrow: nextButton,
					pauseOnFocus: true,
					pauseOnHover: true
				}
			};

		// Load slick.js from CDN
		var loadLib = function() {

			var libScript = document.createElement('script');

			// Run the init on load
			libScript.onload = function() {
				init();
			};

			libScript.setAttribute('src', settings.libUrl);
			document.head.appendChild(libScript);
		},

		init = function() {

			// Add the fullscreen class to the body
			body.addClass(settings.fullscreenClass);

			// A11Y setup
			elem.removeAttr('aria-hidden').attr('role', 'toolbar');

			// Bind our mate slick 
			target.slick(settings.pluginSettings);

			// Add loaded class to elem to show it
			elem.addClass(settings.loadedClass);

			// Next and prev buttons
			nextButton.on('click', function() {
				target.slick('next');
			});

			prevButton.on('click', function() {
				target.slick('prev');
			});

			// Listen for change event
			target.on('afterChange', function(slick, currentSlideItem) {

				// update the thumbs
				updateThumbs(currentSlideItem.currentSlide + 1);
			});

			// Set first dot as active
			updateThumbs(1);

			// Bind click event to thumbs
			thumbControls.on('click', function(evt) {

				evt.preventDefault();

				var thumbItem = $(this);

				// Current slide so let's get outa here
				if(thumbItem.hasClass(settings.activeClass)) {
					return;
				}

				// Toggle the active class so the gallery doesn't feel janky
				thumbItem.addClass(settings.activeClass)
							.siblings()
							.removeClass(settings.activeClass);


				// Run the slick method
				target.slick('slickGoTo', (parseInt(thumbItem.attr(settings.thumbIndexAttr)) - 1));
			});

			// Handle left and right keys
			$(document).keyup(function(evt) {

				switch(evt.keyCode) {
					case 37:
						target.slick('prev');
						break;

					case 39:
						target.slick('next');
						break;
				}
			});

			// Close buttons 
			closeButton.on('click', function(evt) {

				evt.preventDefault();

				close();
			});

			// Bind close to escape
			$.esc({
				callback: function() {
					close();
				}
			});

			setTimeout(function() {
				resizeCaptions();
			}, 100);

			$(window).resize(debounce(function() {
				resizeCaptions();
			}));
		},

		// Update the thumbs based on index
		updateThumbs = function(index) {

			// Clear current thumbs
			thumbControls.removeClass(settings.activeClass);

			// Find the new active thumb
			var newActiveThumb = thumbControls.filter('[' + settings.thumbIndexAttr + '="' + index + '"]');

			// Add active class to the now active dot
			newActiveThumb.addClass(settings.activeClass);
		},

		// Close and clean up the gallery
		close = function() {

			// Remove the fullscreen class to the body
			body.removeClass(settings.fullscreenClass);

			elem.removeClass(settings.activeClass);

			setTimeout(function() {
				elem.remove();
			}, 1000);
		},

		// Make the captions "fit the image"
		resizeCaptions = function() {

			slides.each(function() {

				var slide = $(this),
					image = slide.find(settings.imageSelector),
					caption = slide.find(settings.captionSelector);

				if(caption.any()) {
					caption.css('width', image.width()).addClass(settings.activeClass);
				}

			});
		};

		loadLib();
		return this;
	};

}($));